import React, { useEffect, useState } from "react";
import Navbar from "../../components/Navbar";
import Styles from "../../styles/client/editprofile.module.scss";
import { useNavigate, Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { clientRoutes } from "../../routers/ClientRouters";
import {
  changeClientProfileService,
  getClientProfile,
} from "../../services/clientService";
import Swal from "sweetalert2";
import Close_Button from "../../assets/auth/close.png";
import sucess from "../../assets/dashboard/Menu/success.png";
const EditProfile = () => {
  const { isLoading, profile } = useSelector((state) => state.client);

  const navigate = useNavigate();

  // Form state
  const [formData, setFormData] = useState({
    id: "",
    name: "",
    email: "",
    password: "",
    phone: "",
    dob: "",
    gender: "",
  });

  useEffect(() => {
    getClientProfile();
  }, []);

  useEffect(() => {
    if (profile) {
      setFormData({
        code: profile?.code || "",
        name: profile?.name || "",
        gender: profile?.gender || "",
        dob: profile?.dob || "",
        email: profile?.email || "",
        password: profile?.password || "",
        phone: profile?.phone || "",
      });
    }
  }, [profile]);

  const handleInputChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleSave = async () => {
    // Only send DOB, name, and phone number
    const dataToSend = {
      name: formData.name,
      dob: formData.dob,
      phone: formData.phone,
      gender: formData.gender,
    };

    console.log("Saving profile:", dataToSend);
    const success = await changeClientProfileService(dataToSend);

    if (success) {
      Swal.fire({
        html: `
          <div style="text-align: center; border-radius: 20px; position: relative; font-family: 'gothambold', sans-serif;">
            <button 
              id="customCloseButton" 
              style="position: absolute; top: -10px; right: -20px; background: none; border: none; cursor: pointer;">
              <img 
                src=${Close_Button} 
                alt="Close" 
                style="width: 50px; height: 50px;"
              />
            </button>
            <img 
              src=${sucess} 
              alt="Success" 
              style="width: 100px; margin-bottom: 20px; margin-top: 30px;" 
            />
            <h2 style="margin: 0; font-family: 'gothambold', sans-serif;">Profile Updated!</h2>
            <br/>
            <p style="font-family: 'Gotham Book', sans-serif;">
              You've successfully updated your profile .
            </p>
            <br/>
            <button 
              id="okButton" 
              style="
                background: linear-gradient(0deg, #151515 0%, #525252 100%); 
                color: #f3f3f6; 
                padding: 10px 30px; 
                border: none; 
                border-radius: 5px; 
                cursor: pointer; 
                margin-top: 20px; 
                font-family: 'gothambold', sans-serif;
              ">
             Close
            </button>
          </div>
        `,
        showConfirmButton: false,
        customClass: {
          popup: "custom-swal-container",
        },
        didOpen: () => {
          const thanksButton = document.getElementById("okButton");
          thanksButton.addEventListener("click", () => {
            Swal.close();
          });
        },
      });
    }
  };

  const handleCancel = () => {
    navigate(clientRoutes.profile);
  };

  const handleChangeEmail = () => {
    navigate(clientRoutes.changeEmail);
  };

  const handleChangePassword = () => {
    navigate(clientRoutes.changePassword);
  };

  return (
    <>
      <Navbar />
      <div className={Styles.exercise_list_container_main}>
        <h2>
          <Link to={clientRoutes.dashboard}>HOME / </Link>
          PROFILE / <span>EDIT PROFILE</span>
        </h2>
        <div className={Styles.exercise_list_container}>
          <div className={Styles.table_container_heading}>
            <div className={Styles.table_container_headingone}>
              <h3>EDIT PROFILE</h3>
            </div>
          </div>
          <div className={Styles.borderbottomline}></div>

          <div className={Styles.renderedcontentmaindiv}>
            {isLoading ? (
              <div className={Styles.loading_container}>
                <p>Loading...</p>
              </div>
            ) : (
              <div className={Styles.profilebtnmain}>
                <div className={Styles.profile_form}>
                  <div className={Styles.form_grid}>
                    {/* Row 1 */}
                    <div className={Styles.form_field}>
                      <label className={Styles.field_label}>ID</label>
                      <input
                        type="text"
                        className={`${Styles.form_input} ${Styles.id_input}`}
                        value={formData.code}
                        onChange={(e) =>
                          handleInputChange("id", e.target.value)
                        }
                        placeholder="Enter ID"
                        disabled
                      />
                    </div>

                    <div className={Styles.form_field}>
                      <label className={Styles.field_label}>Name</label>
                      <input
                        type="text"
                        className={Styles.form_input}
                        value={formData.name}
                        onChange={(e) =>
                          handleInputChange("name", e.target.value)
                        }
                        placeholder="Enter name"
                      />
                    </div>

                    <div className={Styles.form_field}>
                      <label className={Styles.field_label}>Gender</label>
                      <select
                        className={Styles.form_input}
                        value={formData.gender}
                        onChange={(e) =>
                          handleInputChange("gender", e.target.value)
                        }
                      >
                        <option value="">Select Gender</option>
                        <option value="MALE">Male</option>
                        <option value="FEMALE">Female</option>
                      </select>
                    </div>

                    <div className={Styles.form_field}>
                      <label className={Styles.field_label}>DOB</label>
                      <input
                        type="text"
                        className={Styles.form_input}
                        value={formData.dob}
                        onChange={(e) =>
                          handleInputChange("dob", e.target.value)
                        }
                        placeholder="Select date of birth"
                      />
                    </div>

                    {/* Row 2 */}
                    <div className={Styles.form_field}>
                      <label className={Styles.field_label}>Email ID</label>
                      <div className={Styles.input_with_button}>
                        <input
                          type="email"
                          className={Styles.form_input}
                          value={formData.email}
                          onChange={(e) =>
                            handleInputChange("email", e.target.value)
                          }
                          placeholder="Enter email"
                          disabled
                        />
                        <button
                          className={Styles.change_button}
                          onClick={handleChangeEmail}
                        >
                          Change
                        </button>
                      </div>
                    </div>

                    <div className={Styles.form_field}>
                      <label className={Styles.field_label}>Password</label>
                      <div className={Styles.input_with_button}>
                        <input
                          type="password"
                          className={Styles.form_input}
                          value={profile?.password || "*********"}
                          onChange={(e) =>
                            handleInputChange("password", e.target.value)
                          }
                          placeholder="Enter password"
                          disabled
                        />
                        <button
                          className={Styles.change_button}
                          onClick={handleChangePassword}
                        >
                          Change
                        </button>
                      </div>
                    </div>

                    <div className={Styles.form_field}>
                      <label className={Styles.field_label}>Phone</label>
                      <input
                        type="tel"
                        className={Styles.form_input}
                        value={formData.phone}
                        onChange={(e) =>
                          handleInputChange("phone", e.target.value)
                        }
                        placeholder="Enter phone number"
                      />
                    </div>
                  </div>
                </div>
                <div className={Styles.borderbottomline}></div>
                <div className={Styles.button_group}>
                  <button className={Styles.save_button} onClick={handleSave}>
                    Save
                  </button>
                  <button
                    className={Styles.cancel_button}
                    onClick={handleCancel}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default EditProfile;
